var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useContext } from 'react';
import { createPrefixCls } from '../_utils/string';
import Icon from '../icon';
import { StyleContext } from './context';
const prefixCls = createPrefixCls('cell');
export const Cell = (_a) => {
    var { children, className, label, description, arrow, align = 'right', labelWidth } = _a, restProps = __rest(_a, ["children", "className", "label", "description", "arrow", "align", "labelWidth"]);
    const cellCls = useMemo(() => {
        return classnames([prefixCls(), className]);
    }, [className]);
    const arrowDirection = useMemo(() => {
        return arrow === true ? 'right' : arrow;
    }, [arrow]);
    const styleContext = useContext(StyleContext);
    return (React.createElement("div", Object.assign({ className: cellCls }, restProps),
        React.createElement("div", { className: prefixCls('label'), style: {
                width: styleContext.labelWidth || labelWidth
            } },
            React.createElement("div", { className: prefixCls('label-text') }, label),
            description && React.createElement("div", { className: prefixCls('label-description') }, description)),
        React.createElement("div", { className: classnames(prefixCls('content'), prefixCls(`content-${styleContext.align || align}`)) }, React.isValidElement(children) ? children : React.createElement("div", { className: prefixCls('content-text') }, children)),
        arrow && React.createElement(Icon, { className: prefixCls('arrow'), name: `arrow-${arrowDirection}` })));
};
export default Cell;
